// Forms App Helper - Simplified version to prevent mobile freezing
(function() {
  'use strict';
  
  // Track if form has been submitted (not just viewed)
  let formSubmitted = false;
  
  // Simple mobile detection
  let isMobile = window.innerWidth <= 768;
  
  function setupFormsBehavior() {
    // Check if Forms app elements exist
    const formsApp = document.querySelector('form-embed, #app-embed-container-572990');
    if (!formsApp) {
      // Try again in a moment if not loaded yet
      setTimeout(setupFormsBehavior, 1000);
      return;
    }
    
    // CRITICAL FIX: Target specific textarea causing clipping issue (mobile + desktop)
    // Apply to all devices since desktop also has the clipping issue
    {
      // Multiple targeting strategies for the problematic textarea
      function fixTextareaClipping() {
        // Strategy 1: Direct textarea targeting
        const textareas = formsApp.querySelectorAll('textarea');
        
        // Strategy 2: Also look for specific content patterns
        const targetTextareas = [];
        textareas.forEach(textarea => {
          // Check if this is the CBD supplement question textarea
          const parentLabel = textarea.closest('div')?.querySelector('label');
          const questionText = parentLabel?.textContent || '';
          
          if (questionText.toLowerCase().includes('cbd supplement') || 
              questionText.toLowerCase().includes('looking for') ||
              textarea.placeholder?.toLowerCase().includes('supplement') ||
              textarea.getAttribute('aria-label')?.toLowerCase().includes('supplement')) {
            targetTextareas.push(textarea);
          } else {
            // Apply to all textareas as fallback
            targetTextareas.push(textarea);
          }
        });
        
        // Fix floating label positioning - reset unfocused state
        const labels = formsApp.querySelectorAll('label');
        labels.forEach(label => {
          label.style.setProperty('transform', 'translateY(0)', 'important');
          label.style.setProperty('top', 'auto', 'important');
          label.style.setProperty('position', 'relative', 'important');
          label.style.setProperty('margin-bottom', '0.5rem', 'important');
        });
        
        // This shouldn't run since we have Shadow DOM, but keep as fallback
        targetTextareas.forEach(textarea => {
          textarea.style.setProperty('padding-top', '1rem', 'important');
          textarea.style.setProperty('margin-top', '1rem', 'important');
          textarea.setAttribute('data-mobile-fixed', 'true');
        });
      }
      
      // Initial fix after slight delay
      setTimeout(fixTextareaClipping, 500);
      
      // DEBUG: Check for Shadow DOM or iframe isolation
      setTimeout(() => {
        console.log('=== FORMS APP SHADOW DOM DEBUG ===');
        console.log('Forms app container:', formsApp);
        
        // Check if it has Shadow DOM
        if (formsApp.shadowRoot) {
          console.log('FOUND SHADOW DOM:', formsApp.shadowRoot);
          const shadowTextareas = formsApp.shadowRoot.querySelectorAll('textarea');
          console.log('Textareas in Shadow DOM:', shadowTextareas);
          
          // FIX Shadow DOM textarea clipping issue - target the specific problematic textarea
          shadowTextareas.forEach(textarea => {
            // Check if this is the problematic textarea by looking at surrounding elements
            const textareaContainer = textarea.parentElement;
            const labelElement = textareaContainer?.querySelector('label');
            const questionText = labelElement?.textContent || textarea.placeholder || '';
            
            if (questionText.toLowerCase().includes('cbd supplement') || 
                questionText.toLowerCase().includes('looking for')) {
              
              console.log('Found problematic textarea:', questionText);
              
              // Target the specific CSS classes from the actual DOM structure
              const container = textarea.closest('._formFieldContainer_ck6wz_5');
              const label = container?.querySelector('._formInputFieldLabel_ck6wz_38');
              
              if (label) {
                // Fix the label positioning for both states
                label.style.setProperty('top', '1rem', 'important');
                
                // Override the _inputFilled_ck6wz_74 class that's causing issues
                if (label.classList.contains('_inputFilled_ck6wz_74')) {
                  label.style.setProperty('transform', 'translateY(0)', 'important');
                  label.style.setProperty('top', '1rem', 'important');
                  console.log('Fixed _inputFilled label positioning');
                }
                
                console.log('Fixed label top position from 2px to 1rem');
              }
              
              // Also add padding to textarea to give text space - massive padding for 3-line question
              if (textarea.classList.contains('_textArea_17mgw_1')) {
                textarea.style.setProperty('padding-top', '6rem', 'important');
                textarea.style.setProperty('overflow-y', 'auto', 'important');
                textarea.style.setProperty('min-height', '140px', 'important');
                console.log('Added massive padding-top and scroll to textarea');
              }
              
              // CRITICAL: Handle focus/blur events to prevent clipping during focus state
              textarea.addEventListener('focus', function() {
                if (label) {
                  // When focused, keep label lower so it doesn't clip into border
                  label.style.setProperty('top', '1rem', 'important');
                  label.style.setProperty('transform', 'translateY(0)', 'important');
                  console.log('Focus: Fixed label position');
                }
                // Ensure textarea has enough padding when focused - massive space below 3-line question
                this.style.setProperty('padding-top', '6.5rem', 'important');
              });
              
              textarea.addEventListener('blur', function() {
                if (label) {
                  // When blurred, keep label at safe position  
                  label.style.setProperty('top', '1rem', 'important');
                  label.style.setProperty('transform', 'translateY(0)', 'important');
                  console.log('Blur: Fixed label position');
                }
              });
            }
          });
        }
        
        // Check for iframes
        const iframes = formsApp.querySelectorAll('iframe');
        console.log('Iframes found:', iframes);
        
        // Look for any textareas in the main DOM
        const mainTextareas = document.querySelectorAll('textarea');
        console.log('Main DOM textareas:', mainTextareas);
        
        // Try to access iframe content
        iframes.forEach((iframe, index) => {
          try {
            console.log(`Iframe ${index} content:`, iframe.contentDocument);
            if (iframe.contentDocument) {
              const iframeTextareas = iframe.contentDocument.querySelectorAll('textarea');
              console.log(`Textareas in iframe ${index}:`, iframeTextareas);
              
              // Apply styles to iframe textareas
              iframeTextareas.forEach(textarea => {
                textarea.style.setProperty('background', 'green', 'important');
                textarea.style.setProperty('padding-top', '3rem', 'important');
                textarea.style.setProperty('margin-top', '2rem', 'important');
                textarea.style.setProperty('min-height', '120px', 'important');
                console.log('Applied styles to iframe textarea:', textarea);
                
                // Also style labels in iframe
                const iframeLabels = iframe.contentDocument.querySelectorAll('label');
                iframeLabels.forEach(label => {
                  label.style.setProperty('background', 'orange', 'important');
                  label.style.setProperty('margin-bottom', '2rem', 'important');
                });
              });
            }
          } catch (e) {
            console.log(`Cannot access iframe ${index} content:`, e);
          }
        });
        
        console.log('=== END SHADOW DOM DEBUG ===');
      }, 1000);
      
      // Monitor for dynamic content changes
      const observer = new MutationObserver(() => {
        // Only fix textareas that haven't been fixed yet
        const unfixedTextareas = formsApp.querySelectorAll('textarea:not([data-mobile-fixed="true"])');
        if (unfixedTextareas.length > 0) {
          fixTextareaClipping();
        }
      });
      
      observer.observe(formsApp, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }
    
    // Create our own blur overlay (simplified)
    let blurOverlay = document.querySelector('.forms-app-blur-overlay');
    if (!blurOverlay) {
      blurOverlay = document.createElement('div');
      blurOverlay.className = 'forms-app-blur-overlay';
      document.body.appendChild(blurOverlay);
    }
    
    // Simplified close handling without complex mobile interventions
    function handleCloseClick(e) {
      console.log('Close button clicked');
      
      // Find the Forms app container
      const container = e.target.closest('form-embed, #app-embed-container-572990');
      if (container) {
        // Remove our blur overlay completely
        const blurOverlay = document.querySelector('.forms-app-blur-overlay');
        if (blurOverlay) {
          blurOverlay.remove();
        }
        
        // Hide the entire container
        container.style.display = 'none';
        
        // CRITICAL: Restore mobile scrolling after closing popup
        if (isMobile) {
          document.body.style.overflow = '';
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';
          document.body.style.height = '';
          document.documentElement.style.overflow = '';
          
          // Force layout recalculation
          document.body.offsetHeight;
          window.dispatchEvent(new Event('resize'));
          
          console.log('Mobile scroll restored after form close');
        }
        
        console.log('Form closed and blur removed');
        
        // Mark as viewed/dismissed (but not submitted)
        localStorage.setItem('forms-app-viewed', 'true');
        localStorage.setItem('forms-app-last-viewed', new Date().toDateString());
        
        // Mark as dismissed for current session to prevent re-showing on page navigation
        sessionStorage.setItem('forms-app-dismissed-session', 'true');
      }
    }
    
    // Handle form submission
    function handleFormSubmit(e) {
      console.log('Form submitted');
      formSubmitted = true;
      
      // Mark as actually submitted
      localStorage.setItem('forms-app-submitted', 'true');
      localStorage.setItem('forms-app-submission-date', new Date().toISOString());
      
      // Also trigger mobile scroll to top if needed
      if (isMobile) {
        setTimeout(() => {
          if (window.scrollToTopMobile) {
            window.scrollToTopMobile();
          } else {
            // Fallback mobile scroll to top
            window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
          }
        }, 100);
      }
    }
    
    // Set up event listeners with delegation for dynamic content
    document.addEventListener('click', function(e) {
      // Handle various close button selectors
      if (e.target.matches('._formCloseButton_1684x_4, button[aria-label*="close"], button[title*="close"], button[data-action*="close"]') ||
          e.target.closest('._formCloseButton_1684x_4, button[aria-label*="close"], button[title*="close"], button[data-action*="close"]')) {
        handleCloseClick(e);
      }
    });
    
    // Listen for form submissions within Forms app
    document.addEventListener('submit', function(e) {
      if (e.target.closest('form-embed, #app-embed-container-572990')) {
        handleFormSubmit(e);
      }
    });
    
    // Check if form should be shown based on submission history
    function shouldShowForm() {
      // Don't show if actually submitted
      if (localStorage.getItem('forms-app-submitted') === 'true') {
        return false;
      }
      
      // Don't show if dismissed during current session
      if (sessionStorage.getItem('forms-app-dismissed-session') === 'true') {
        return false;
      }
      
      // Don't show if dismissed today
      const lastViewed = localStorage.getItem('forms-app-last-viewed');
      const today = new Date().toDateString();
      
      if (lastViewed === today && localStorage.getItem('forms-app-viewed') === 'true') {
        return false;
      }
      
      // Show the form
      return true;
    }
    
    // Apply show/hide logic
    if (!shouldShowForm() && formsApp) {
      formsApp.style.display = 'none';
    }
    
    console.log('Forms app behavior setup complete');
    console.log('DEBUG: JS is loading and running');
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupFormsBehavior);
  } else {
    setupFormsBehavior();
  }
  
  // STYLE THE POPUP BUTTON - Use MutationObserver to detect Shadow DOM insertion
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE && node.id && node.id.startsWith('app-embed')) {
            console.log('Found Forms app shadow host:', node.id);
            
            const shadowHost = node;
            const shadowRoot = shadowHost.shadowRoot;
            
            if (shadowRoot) {
              console.log('Accessing shadow DOM to style popup button');
              
              const styleElement = document.createElement('style');
              styleElement.textContent = `
                /* Cosmic CBD Survey Teaser - Complete Galaxy Theme for Shopify */
                button._teaserContainer_trejf_5 {
                  position: relative !important;
                  background: 
                    radial-gradient(ellipse at top left, rgba(199, 102, 255, 0.25) 0%, transparent 50%),
                    radial-gradient(ellipse at bottom right, rgba(147, 51, 234, 0.35) 0%, transparent 50%),
                    radial-gradient(ellipse at center, rgba(168, 85, 247, 0.2) 0%, transparent 70%),
                    linear-gradient(135deg, 
                      #1a1832 0%,
                      #201e3f 10%,
                      #26244c 20%,
                      #2c2a59 30%,
                      #323066 40%,
                      #383673 50%,
                      #453c80 60%,
                      #52428d 70%,
                      #5f489a 80%,
                      #6b4ea7 90%,
                      #7754b4 100%) !important;
                  border: 2px solid transparent !important;
                  border-radius: 20px !important;
                  padding: 2rem 2.5rem !important;
                  cursor: pointer !important;
                  overflow: hidden !important;
                  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1), box-shadow 0.3s cubic-bezier(0.23, 1, 0.32, 1) !important;
                  box-shadow:
                    0 15px 35px rgba(138, 43, 226, 0.25),
                    0 5px 15px rgba(75, 0, 130, 0.3),
                    inset 0 1px 0 rgba(255, 255, 255, 0.1) !important;
                  animation: none !important;
                }

                /* Enhanced starfield with scattered positioning - avoiding text area */
                button._teaserContainer_trejf_5::before {
                  content: '' !important;
                  position: absolute !important;
                  top: 0 !important;
                  left: 0 !important;
                  right: 0 !important;
                  bottom: 0 !important;
                  background: 
                    /* Top edge stars */
                    radial-gradient(1px 1px at 25px 8px, rgba(255, 255, 255, 0.9), transparent),
                    radial-gradient(1px 1px at 75px 12px, rgba(255, 255, 255, 0.7), transparent),
                    radial-gradient(2px 2px at 125px 15px, rgba(147, 51, 234, 0.8), transparent),
                    radial-gradient(1px 1px at 175px 10px, rgba(255, 255, 255, 0.6), transparent),
                    radial-gradient(1px 1px at 210px 18px, rgba(139, 69, 199, 0.7), transparent),
                    /* Bottom edge stars */
                    radial-gradient(1px 1px at 35px 85px, rgba(255, 255, 255, 0.8), transparent),
                    radial-gradient(2px 2px at 85px 90px, rgba(147, 51, 234, 0.6), transparent),
                    radial-gradient(1px 1px at 135px 88px, rgba(255, 255, 255, 0.7), transparent),
                    radial-gradient(1px 1px at 185px 92px, rgba(255, 255, 255, 0.5), transparent),
                    radial-gradient(2px 2px at 225px 87px, rgba(139, 69, 199, 0.8), transparent),
                    /* Left edge scattered */
                    radial-gradient(1px 1px at 8px 35px, rgba(255, 255, 255, 0.6), transparent),
                    radial-gradient(1px 1px at 15px 65px, rgba(147, 51, 234, 0.7), transparent),
                    /* Right edge scattered */
                    radial-gradient(1px 1px at 235px 40px, rgba(255, 255, 255, 0.8), transparent),
                    radial-gradient(2px 2px at 240px 70px, rgba(139, 69, 199, 0.6), transparent),
                    /* Corner accents */
                    radial-gradient(1px 1px at 12px 12px, rgba(255, 255, 255, 0.9), transparent),
                    radial-gradient(1px 1px at 238px 88px, rgba(147, 51, 234, 0.8), transparent),
                    /* Subtle nebula clouds in corners */
                    radial-gradient(ellipse 30px 15px at 15px 25px, rgba(138, 43, 226, 0.08), transparent),
                    radial-gradient(ellipse 25px 12px at 220px 75px, rgba(75, 0, 130, 0.1), transparent) !important;
                  background-repeat: repeat !important;
                  background-size: 250px 100px !important;
                  animation: galaxyDrift 10s linear infinite !important;
                  opacity: 0.8 !important;
                  pointer-events: none !important;
                }

                /* Glowing border effect with galaxy colors */
                button._teaserContainer_trejf_5::after {
                  content: '' !important;
                  position: absolute !important;
                  top: -2px !important;
                  left: -2px !important;
                  right: -2px !important;
                  bottom: -2px !important;
                  background: linear-gradient(45deg, 
                    #9333ea, #4b0082, #191970, #2e0854, #8a2be2, #9333ea) !important;
                  border-radius: 22px !important;
                  z-index: -1 !important;
                  animation: none !important;
                  opacity: 0.6 !important;
                }

                /* Hover state - transform only, no color changes */
                button._teaserContainer_trejf_5:hover {
                  transform: translateY(-3px) scale(1.02) !important;
                  /* Keep exact same box-shadow colors - no changes */
                }

                /* No changes to stars opacity on hover */

                /* No changes to border glow on hover */

                /* Text styling */
                ._teaserHeading_trejf_28 {
                  color: #ffffff !important;
                  text-shadow:
                    0 0 10px rgba(255, 255, 255, 0.5),
                    0 0 20px rgba(138, 43, 226, 0.3),
                    0 2px 4px rgba(0, 0, 0, 0.3) !important;
                  font-weight: 600 !important;
                  font-size: 1.1em !important;
                  margin: 0 !important;
                  position: relative !important;
                  z-index: 2 !important;
                  letter-spacing: 0.5px !important;
                }

                /* Optional: Add a subtle glow icon effect */
                ._teaserHeading_trejf_28::before {
                  content: '✨' !important;
                  margin-right: 8px !important;
                  font-size: 1.2em !important;
                  animation: iconTwinkle 2s ease-in-out infinite alternate !important;
                }

                /* Keyframe animations */
                @keyframes galaxyDrift {
                  0% { transform: translateX(0px); }
                  100% { transform: translateX(-250px); }
                }


                @keyframes gentlePulse {
                  0%, 100% { 
                    box-shadow: 
                      0 15px 35px rgba(138, 43, 226, 0.25),
                      0 5px 15px rgba(75, 0, 130, 0.3),
                      inset 0 1px 0 rgba(255, 255, 255, 0.1);
                  }
                  50% { 
                    box-shadow: 
                      0 20px 40px rgba(138, 43, 226, 0.35),
                      0 8px 20px rgba(75, 0, 130, 0.4),
                      inset 0 1px 0 rgba(255, 255, 255, 0.15);
                  }
                }

                @keyframes iconTwinkle {
                  0% { opacity: 0.7; transform: scale(1); }
                  100% { opacity: 1; transform: scale(1.1); }
                }

                /* Adjust FORM close button positioning (not teaser) - target all possible close button classes */
                ._formCloseButton_1684x_4,
                button[aria-label*="close"],
                button[title*="close"],
                button[data-action*="close"],
                ._closeButton_1684x_4,
                [class*="closeButton"],
                [class*="CloseButton"],
                [class*="close-button"] {
                  position: absolute !important;
                  top: 12px !important;
                  right: 12px !important;
                  z-index: 10 !important;
                }

                ._formCloseButton_1684x_4:hover,
                button[aria-label*="close"]:hover,
                button[title*="close"]:hover,
                button[data-action*="close"]:hover {
                  background: transparent !important;
                  transform: scale(1.1) !important;
                }

                ._formCloseButton_1684x_4 svg,
                button[aria-label*="close"] svg,
                button[title*="close"] svg,
                button[data-action*="close"] svg {
                  filter: none !important;
                  box-shadow: none !important;
                  text-shadow: none !important;
                }
                
                /* Override any other shadow sources */
                ._formCloseButton_1684x_4,
                ._formCloseButton_1684x_4:before,
                ._formCloseButton_1684x_4:after,
                ._formCloseButton_1684x_4 *,
                ._formCloseButton_1684x_4 svg,
                ._formCloseButton_1684x_4 svg *,
                ._formCloseButton_1684x_4 svg path,
                button[aria-label*="close"],
                button[aria-label*="close"] *,
                button[aria-label*="close"] svg,
                button[aria-label*="close"] svg * {
                  filter: none !important;
                  box-shadow: none !important;
                  text-shadow: none !important;
                  drop-shadow: none !important;
                }
              `;
              
              shadowRoot.appendChild(styleElement);
              console.log('Successfully injected sophisticated popup button styling into shadow DOM');
              
              // Change teaser popup text to "Get your free sample!"
              setTimeout(() => {
                const teaserHeading = shadowRoot.querySelector('._teaserHeading_trejf_28');
                if (teaserHeading) {
                  teaserHeading.textContent = 'Get your free sample!';
                  console.log('Updated teaser text to: Get your free sample!');
                }
              }, 100);
            }
          }
        });
      }
    });
  });

  const targetNode = document.body;
  const config = { childList: true, subtree: true };
  observer.observe(targetNode, config);
  console.log('MutationObserver started - watching for Forms app insertion');
  
  // Also try after a delay to catch dynamically loaded Forms app
  setTimeout(setupFormsBehavior, 2000);
  
  // Debugging helper - call from console to reset form state
  window.resetFormsApp = function() {
    // Clear our tracking
    localStorage.removeItem('forms-app-viewed');
    localStorage.removeItem('forms-app-last-viewed');
    localStorage.removeItem('forms-app-submitted');
    localStorage.removeItem('forms-app-submission-date');
    sessionStorage.removeItem('forms-app-dismissed-session');
    
    // Clear potential Forms app storage keys
    // Based on form_instance_id: 572990
    localStorage.removeItem('form_572990_submitted');
    localStorage.removeItem('form_572990_closed');
    localStorage.removeItem('form_572990_shown');
    localStorage.removeItem('shopify_forms_572990');
    localStorage.removeItem('forms_app_572990');
    
    // Clear generic Forms app keys
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (
        key.includes('572990') ||
        key.includes('form') ||
        key.includes('popup') ||
        key.includes('survey') ||
        key.startsWith('_form') ||
        key.startsWith('shopify_form')
      )) {
        keysToRemove.push(key);
      }
    }
    
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
      console.log('Removed:', key);
    });
    
    // Also clear sessionStorage
    const sessionKeysToRemove = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && (
        key.includes('572990') ||
        key.includes('form') ||
        key.includes('popup') ||
        key.includes('survey')
      )) {
        sessionKeysToRemove.push(key);
      }
    }
    
    sessionKeysToRemove.forEach(key => {
      sessionStorage.removeItem(key);
      console.log('Removed from session:', key);
    });
    
    console.log('Forms app state completely reset. Refresh page to see form again.');
  };
  
})();